import type { MouseEventHandler } from 'react'
import React, { useEffect, useRef, useState } from 'react'

import { Button, type ButtonProps } from '@fourthwall/components'

import * as S from './CopyButton.styled'

export type CopyButtonProps = ButtonProps & {
  copyValue: string
  copiedLabel?: string
}

export const CopyButton = ({ copyValue, copiedLabel = 'Copied', ...props }: CopyButtonProps) => {
  const [label, setLabel] = useState(props.label)
  const setTimeoutRef = useRef<ReturnType<typeof setTimeout>>()

  useEffect(() => {
    return () => {
      clearTimeout(setTimeoutRef.current)
    }
  }, [])

  const handleCopy = () => {
    window.navigator.clipboard.writeText(copyValue)
    setLabel(copiedLabel)

    clearTimeout(setTimeoutRef.current)
    setTimeoutRef.current = setTimeout(() => {
      setLabel(props.label)
    }, 2000)
  }

  const handleClick: MouseEventHandler<HTMLButtonElement> = (e) => {
    handleCopy()
    props.onClick?.(e)
  }

  return (
    <S.Container>
      <Button {...props} label={label} fullWidth onClick={handleClick} />
    </S.Container>
  )
}
